/**
 * Redux middleware for debugging selection-related actions
 * Logs selection actions and state changes to help identify issues
 * 
 * Simplified version to reduce console spam and prevent re-renders
 */
export const selectionDebugMiddleware = store => next => action => {
  // Execute the action FIRST to avoid causing extra renders
  const result = next(action);

  // Only log selection-related actions (not during initialization)
  // if (action.type.includes('setSelection') ||
  //   action.type.includes('clearSelection')) {

  //   // Get the state after the action has been processed
  //   const state = store.getState().user.voiceActor;

  //   // Log a simplified version of the action and state
  //   console.log('[REDUX] Selection:', {
  //     action: action.type,
  //     level: action.payload,
  //     current: {
  //       actorUser: state.selectionId?.actorUser,
  //       portfolio: state.selectionId?.portfolio,
  //       character: state.selectionId?.character,
  //       variation: state.selectionId?.variation
  //     }
  //   });
  // }

  // Only log initialization actions
  // if (action.type.includes('initializeSelections')) {
  //   console.log('[REDUX] Selections Initialization:', action.type);
  // }

  // Log entity fetch actions only when debugging is needed
  // Uncomment this section when you need to debug entity fetching
  /*
  if (action.type.includes('/fulfilled') &&
      (action.type.includes('fetchActorUser') ||
       action.type.includes('fetchActorPortfolio') ||
       action.type.includes('fetchRecordedCharacter') ||
       action.type.includes('fetchCharacterVariation'))) {
    console.log('[REDUX] Entity Fetched:', {
      type: action.type
    });
  }
  */

  return result;
};
